import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FlatButton as MuiFlatButton,
  Dialog as MuiDialog
} from 'material-ui';
import styles from '../../../shared-styles';
import './shared-styles.css';
import modalStyles from './modal-styles';

export class Actions extends Component {
  setAddress = async () => {
    try {
      await this.props.onAddressVerified(this.props.verifyAddress);
    } catch (err) {
      this.props.onError(err.message);
    }
  }

  render() {
    return (
      <div className="actions-container">
        <MuiFlatButton
          label="Cancel"
          labelStyle={ modalStyles.modalLabel }
          onClick={ this.props.cancelValidation }
          className="button-cancel left"
          hoverColor="transparent"
          rippleColor="transparent"
        />
        <MuiFlatButton
          label="Confirm"
          labelStyle={ modalStyles.modalLabel }
          onClick={ this.setAddress }
          className="button-confirm"
          hoverColor="transparent"
          rippleColor="transparent"
          keyboardFocused
        />
      </div>
    );
  }
};

Actions.propTypes = {
  cancelValidation: PropTypes.func.isRequired,
  verifyAddress: PropTypes.object.isRequired,
  onError: PropTypes.func.isRequired,
  onAddressVerified: PropTypes.func.isRequired
};

export const DialogContent = (props) => {
  return (
    <div className="shipping-dialog">
      <h4>Is this your correct address?</h4>
      <div>
        <p>{ props.verifyAddress.address1 }</p>
        { props.verifyAddress.address2 }
        <p>{ props.verifyAddress.city }, { props.verifyAddress.state }</p>
        <p>{ props.verifyAddress.postalCode }</p>
        <p>{ props.verifyAddress.country }</p>
      </div>
    </div>
  );
};

DialogContent.propTypes = {
  verifyAddress: PropTypes.object.isRequired
};

export class ConfirmAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleError = (error) => {
    this.setState({ error });
  }

  render() {
    return (
      <MuiDialog
        title="Confirm Address"
        actions={ <Actions { ...this.props } onError={ this.handleError } /> }
        titleStyle={ modalStyles.title }
        bodyStyle={ modalStyles.content }
        contentStyle={ modalStyles.modal }
        open
      >
        <DialogContent { ...this.props } />
        { this.state.error
          ? <p className="error-text" style={ styles.errorStyle }>{ this.state.error }</p>
          : null
        }
      </MuiDialog>
    );
  }
};

ConfirmAddress.propTypes = {
  cancelValidation: PropTypes.func.isRequired,
  verifyAddress: PropTypes.object.isRequired,
  onAddressVerified: PropTypes.func.isRequired
};

export default ConfirmAddress;
